import { Component, ViewEncapsulation, OnInit, Input, ViewChild, forwardRef, OnChanges, SimpleChanges, Output, EventEmitter, ComponentRef, ElementRef } from "@angular/core";
import * as moment_ from 'moment'; const moment = moment_
import { OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { NpDateRangePickerPopup } from "../components/date-range-picker-popup";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../date-picker-const";
import { DatePickerFooterItem } from "../components/date-picker-footer";
import { NpInput } from "../../input";
import { NpDatePickerService, DayDataPerMonth } from "../date-picker.service";

/**
 * Date range pickerç»ä»¶
 */
@Component({
  selector: `np-date-range-picker`,
  templateUrl: 'date-range-picker.html',
  styleUrls: ['date-range-picker.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NpDateRangePicker),
      multi: true,
    }
  ]
})

export class NpDateRangePicker implements OnInit, OnChanges, ControlValueAccessor {

  /**æ ç­¾ */
  @Input() label: string;
  /**æ¯å¦å¿å¡«ï¼trueä»å¨æ ç­¾åé¢æ·»å çº¢è²*å·ï¼ falseä¸å */
  @Input() isRequired: boolean;
  /**å±ç¤ºå¼å§æ¶é´å ä½ç¬¦ */
  @Input() startPlaceholder: string = '';
  /**å±ç¤ºç»ææ¶é´å ä½ç¬¦ */
  @Input() endPlaceholder: string = '';
  /**æ ¡éªéè¯¯æ¶æ¾ç¤ºéè¯¯ä¿¡æ¯ */
  @Input() errorMessage: string;
  /**æ¯å¦ç¦ç¨ */
  @Input() isDisabled: boolean;

  /**å·²éæ¶é´ */
  @Input() dates: Array<moment_.Moment | string> = [];
  /**æ¥ææ¶é´å±ç¤ºæ ¼å¼ï¼é»è®¤åªå±ç¤ºæ¥æ */
  @Input() format: string = DATE_FORMAT;
  /**æ¯å¦å±ç¤ºæ¶é´ï¼é»è®¤ä¸å±ç¤º */
  @Input() isShowTime: boolean = false;
  /**æ¾ç¤ºå¨footerå·¦ä¾§çèªå®ä¹æ¶é´æ ç­¾æ°ç»ï¼å¦âæ¨å¤©âç­ */
  @Input() footerItems: DatePickerFooterItem[] = [];

  @Output() onDateRangeChanged = new EventEmitter<any>();

  @ViewChild('dateRangeWrapper') dateRangeWrapper: ElementRef<HTMLElement>;
  @ViewChild('dateRangeStartPicker') dateRangeStartPicker: NpInput;
  @ViewChild('dateRangeEndPicker') dateRangeEndPicker: NpInput;

  daterangePickerPopupRef: ComponentRef<NpDateRangePickerPopup>;


  startDate: moment_.Moment | string;
  endDate: moment_.Moment | string;

  private overlayRef: OverlayRef;
  isHover: boolean = false;

  private emitChange = (_: any) => { };


  /**æ¥æè¾å¥æ¡ææ¬å¼ï¼æ¯å½this.startDateæ¹åæ¶æ­¤å¼ä¼åæ­¥æ¹å*/
  sValue: string;


  /**æ¥æè¾å¥æ¡ææ¬å¼ï¼æ¯å½this.endDateæ¹åæ¶æ­¤å¼ä¼åæ­¥æ¹å*/
  eValue: string;

  constructor(private datePickerService: NpDatePickerService) { }

  ngOnInit() {
    if (this.dates && this.dates.length === 2) {
      let dates = this.datePickerService.buildStartAndEndDates(moment(this.dates[0]).clone(), moment(this.dates[1]).clone());
      this.startDate = dates[0];
      this.endDate = dates[1];
      this.syncSValue();
      this.syncEValue();
    }

    this.overlayRef = this.datePickerService.getOverlayRef(this.dateRangeStartPicker.npInput);

    if (this.isShowTime) {
      this.format = DATE_TIME_FORMAT;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  onStartPickerClicked() {
    this.onToggleDatePickerPopup();
  }

  onEndPickerClicked() {
    this.onToggleDatePickerPopup();
  }

  onToggleDatePickerPopup() {
    if (this.isDisabled) {
      return;
    }

    if (this.overlayRef.hasAttached()) {
      this.closePopup();
      return;
    }

    this.daterangePickerPopupRef = this.overlayRef.attach(new ComponentPortal(NpDateRangePickerPopup));
    this.daterangePickerPopupRef.instance.datePickerType = 'date-range-picker';
    this.daterangePickerPopupRef.instance.footerItems = this.footerItems;
    this.daterangePickerPopupRef.instance.startDate = moment(this.startDate);
    this.daterangePickerPopupRef.instance.endDate = moment(this.endDate);
    this.subscribeNotifyEvents();

    this.overlayRef.backdropClick().subscribe(() => {
      this.closePopup();
    });

    if (this.dateRangeWrapper && this.dateRangeWrapper.nativeElement) {
      this.dateRangeWrapper.nativeElement.focus();
    }
  }

  onStartDateBlur(data: { value: any, event: any }) {
    if (this.datePickerService.isValid(data.value)) {
      this.startDate = moment(data.value, this.format).clone();
    } else {
      // å¦æè¾å¥æ¥æä¸åæ³ï¼é»è®¤å½åæ¶é´
      this.startDate = moment().clone();
    }

    let dates = this.datePickerService.buildStartAndEndDates(moment(this.startDate).clone(), moment(this.endDate).clone());
    this.startDate = dates[0];
    this.endDate = dates[1];
    this.syncSValue();
    this.syncEValue();
    this.emitChange([this.startDate, this.endDate]);
    this.onDateRangeChanged.emit([this.startDate, this.endDate]);
  }

  onEndDateBlur(data: { value: any, event: any }) {
    if (this.datePickerService.isValid(data.value)) {
      this.endDate = moment(data.value, this.format).clone();
    } else {
      // å¦æè¾å¥æ¥æä¸åæ³ï¼é»è®¤å½åæ¶é´
      this.endDate = moment().clone();
    }

    let dates = this.datePickerService.buildStartAndEndDates(moment(this.startDate).clone(), moment(this.endDate).clone());
    this.startDate = dates[0];
    this.endDate = dates[1];
    this.syncSValue();
    this.syncEValue();
    this.emitChange([this.startDate, this.endDate]);
    this.onDateRangeChanged.emit([this.startDate, this.endDate]);
  }

  onClear() {
    if (this.isDisabled) {
      return;
    }

    this.startDate = null;
    this.endDate = null;
    this.syncSValue();
    this.syncEValue();

    this.emitChange([]);
    this.onDateRangeChanged.emit([]);
  }

  onMouseenter() {
    this.isHover = true;
  }

  onMouseleave() {
    this.isHover = false;
  }

  //#region Private methods

  /**æ¯æ¬¡this.startDateæ¹åæ¶ï¼è¿ä¸ªæ¹æ³é½å¿é¡»è¦è°ç¨ */
  private syncSValue() {
    if (this.startDate && this.datePickerService.isValid(this.startDate)) {
      this.sValue = moment(this.startDate, this.format).format(this.format);
    } else {
      this.sValue = '';
    }
  }

  /**æ¯æ¬¡this.endDateæ¹åæ¶ï¼è¿ä¸ªæ¹æ³é½å¿é¡»è¦è°ç¨ */
  private syncEValue() {
    if (this.endDate && this.datePickerService.isValid(this.endDate)) {
      this.eValue = moment(this.endDate, this.format).format(this.format);
    } else {
      this.eValue = '';
    }
  }

  private closePopup() {
    if (this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }

  private subscribeNotifyEvents() {
    this.daterangePickerPopupRef.instance.onStartDayClicked.subscribe((res: { day: DayDataPerMonth, dates: Array<any> }) => {
      if (this.datePickerService.isValid(this.endDate)) {
        this.emitDataAndClosePopup([res.day.date, moment(this.endDate).clone()]);
      } else {
        this.startDate = res.day.date;
        this.syncSValue();
      }
    });

    this.daterangePickerPopupRef.instance.onEndDayClicked.subscribe((res: { day: DayDataPerMonth, dates: Array<any> }) => {
      if (this.datePickerService.isValid(this.startDate)) {
        this.emitDataAndClosePopup([res.day.date, moment(this.startDate).clone()]);
      } else {
        this.endDate = res.day.date;
        this.syncEValue();
      }
    });

    this.daterangePickerPopupRef.instance.onItemLabelClicked.subscribe((res: DatePickerFooterItem) => {
      if (res && res.values && res.values.length === 2) {
        if (((res.values[0]) instanceof Function) && ((res.values[1]) instanceof Function)) {
          this.emitDataAndClosePopup([(<any>res.values[0])(), (<any>res.values[1])()]);
        } else {
          this.emitDataAndClosePopup([moment(<any>res.values[0]), moment(<any>res.values[1])]);
        }
      }
    });
  }

  private emitDataAndClosePopup(dates: Array<moment_.Moment>) {
    let sortedDates = this.datePickerService.sortDates(dates);
    this.startDate = sortedDates[0].clone();
    this.endDate = sortedDates[sortedDates.length - 1].clone();
    this.syncSValue();
    this.syncEValue();
    this.emitChange([this.startDate, this.endDate]);
    this.onDateRangeChanged.emit([this.startDate, this.endDate]);
    this.closePopup();
  }
  //#endregion

  //#region Implement for ControlValueAccessor
  writeValue(obj: any): void {
    if (obj && obj.length === 2 && this.datePickerService.isValid(obj[0]) && this.datePickerService.isValid(obj[1])) {
      let sortedDates = this.datePickerService.sortDates(obj);
      this.startDate = sortedDates[0].clone();
      this.endDate = sortedDates[sortedDates.length - 1].clone();
    } else {
      this.startDate = null;
      this.endDate = null;
    }

    this.syncSValue();
    this.syncEValue();
  }

  registerOnChange(fn: any): void {
    this.emitChange = fn;
  }

  registerOnTouched(fn: any): void { }
  //#endregion
}